/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRegistrationV1PrincipalEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_REGISTRATION_V1_PRINCIPAL_EVENT_ENTITY_NAME = 'ixc.registration.v1.PrincipalEvent';
export const ixcRegistrationV1PrincipalEventEntity = new schema.Entity<IxcRegistrationV1PrincipalEvent>(IXC_REGISTRATION_V1_PRINCIPAL_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcRegistrationV1PrincipalEvent) => `${entity.metadata?.eventId}` });

